import { DateTime } from 'luxon';
// import { identityCardSchema } from 'person/utils/detail/validation-schema/documents';
// import { birthdayDocumentSchema } from 'person/utils/detail/validation-schema/generality';
import { civilStatusSchema } from 'shell/utils/validation-schema-consult-person/marital-status';
// import { BirthdayDocument } from 'shell/view-models/birthday-document';
// import { drivingLicenseBookletSchema } from 'person/utils/detail/validation-schema/other-datas';
import {
  AccordionCivilStatus,
  NewPersonVM,
} from 'shell/components/shared/sipo-person-form/new-person';
// import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { CivilStatusID } from 'shell/constants/civil-status';
import {
  alphanumericRegex,
  nameSurnameMoreCharactersAccentsRegex,
  portionRegex,
  regexalphaNumericWithDotSlash,
  regexNumericFiscalCode,
  regexOnlyNumber,
  fiscalCodeRegex,
  regexYear,
  seriesRegex,
  volumeRegex,
} from 'shell/constants/regex';
import * as yup from 'yup';

const widowhoodSchema = yup.object().shape({
  isForeign: yup.boolean().nullable(),
  italian: yup.object().when('isForeign', {
    is: false,
    then: yup.object().shape({
      municipality: yup.object().nullable().shape({}),
    }),
    otherwise: yup.object().shape({
      municipality: yup.object().nullable().notRequired().shape({}),
      province: yup.string().notRequired().nullable(),
    }),
  }),
  documentDate: yup
    .date()
    .nullable()
    .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna')
    .min(yup.ref('eventDate'), "Il campo data atto non può essere minore della data dell'evento"),
  foreign: yup.object().when('isForeign', {
    is: true,
    then: yup.object().shape({
      municipality: yup.object().shape({}).nullable(),
      state: yup.object().nullable().shape({}),
    }),
    otherwise: yup.object().shape({
      municipality: yup.string().nullable().notRequired(),
      state: yup.object().nullable().notRequired().shape({}),
    }),
  }),
  year: yup.string().matches(regexYear, 'Il campo deve essere una data'),
  portion: yup.string().matches(portionRegex, 'Il campo può essere solo un numero tra 1 e 2'),
  range: yup.string().matches(seriesRegex, 'Il campo non è valido'),
  documentNumber: yup
    .string()
    .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
  regVol: yup.string().matches(volumeRegex, 'Il campo non è valido'),
  eventDate: yup.date().nullable().typeError('Data non valida'),
});

const generalitySchema = yup
  .object()
  .nullable()
  .shape({
    fiscalCode: yup.string().nullable().notRequired(),
    birthDate: yup
      .date()
      .nullable()
      .notRequired()
      .required('Campo obbligatorio')
      .typeError('Formato non valido')
      .max(
        DateTime.local().plus({ days: 1 }),
        'La data non può essere successiva alla data odierna'
      ),
    withoutSurname: yup.boolean().nullable().notRequired(),
    surname: yup
      .string()
      .nullable()
      .notRequired()
      // .matches(nameSurnameMoreCharactersAccentsRegex, 'Formato non valido')
      .when('withoutSurname', (withoutSurname: boolean, formValidationSchema) => {
        return withoutSurname
          ? formValidationSchema.nullable()
          : formValidationSchema.required('Campo obbligatorio');
      }),
    withoutName: yup.boolean().nullable().notRequired(),
    name: yup
      .string()
      .nullable()
      .notRequired()
      // .matches(nameSurnameMoreCharactersAccentsRegex, 'Formato non valido')
      .when('withoutName', (withoutSurname: boolean, formValidationSchema) => {
        return withoutSurname
          ? formValidationSchema.nullable()
          : formValidationSchema.required('Campo obbligatorio');
      }),
    gender: yup.string().nullable().required('Campo obbligatorio'),
    isForeign: yup.boolean().nullable(),
    italian: yup.object().when('isForeign', {
      is: false,
      then: yup.object().shape({
        municipality: yup.object().nullable().required('Campo obbligatorio').shape({}),
      }),
      otherwise: yup.object().shape({
        municipality: yup.object().shape({}).notRequired().nullable(),
      }),
    }),
    foreign: yup.object().when('isForeign', {
      is: true,
      then: yup.object().shape({
        municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
        state: yup.object().shape({}).nullable().required('Campo obbligatorio'),
      }),
      otherwise: yup.object().shape({
        municipality: yup.object().shape({}).nullable().notRequired(),
        state: yup.object().shape({}).nullable().notRequired(),
      }),
    }),
  });

const generalityPerson = yup
  .object()
  .nullable()
  .shape({
    birthDate: yup
      .date()
      .nullable()
      .notRequired()
      .typeError('Formato non valido')
      .max(
        DateTime.local().plus({ days: 1 }),
        'La data non può essere successiva alla data odierna'
      ),
    withoutSurname: yup.boolean().nullable().notRequired(),
    surname: yup
      .string()
      .nullable()
      .notRequired()
      .matches(nameSurnameMoreCharactersAccentsRegex, 'Formato non valido'),
    withoutName: yup.boolean().nullable().notRequired(),
    name: yup
      .string()
      .nullable()
      .notRequired()
      .matches(nameSurnameMoreCharactersAccentsRegex, 'Formato non valido'),
    gender: yup.string().nullable().notRequired(),
    isForeign: yup.boolean().nullable(),
    italian: yup.object().when('isForeign', {
      is: false,
      then: yup.object().shape({
        municipality: yup.object().nullable().shape({}),
      }),
      otherwise: yup.object().shape({
        municipality: yup.object().shape({}).notRequired().nullable(),
      }),
    }),
    foreign: yup.object().when('isForeign', {
      is: true,
      then: yup.object().shape({
        municipality: yup.object().shape({}).nullable(),
        state: yup.object().shape({}).nullable(),
      }),
      otherwise: yup.object().shape({
        municipality: yup.object().shape({}).nullable().notRequired(),
        state: yup.object().shape({}).nullable().notRequired(),
      }),
    }),
  });

const parentSchema = yup.object().nullable().shape({
  // generality: generalityPerson,
});

const marriageSchema = yup.object().shape({
  generality: generalityPerson,
  isForeign: yup.boolean(),
  italian: yup.object().when('isForeign', {
    is: false,
    then: yup
      .object()
      .nullable()
      .shape({
        municipality: yup.object().nullable().shape({}),
      }),
    otherwise: yup
      .object()
      .nullable()
      .shape({
        municipality: yup.object().notRequired().nullable().shape({}),
        province: yup.string().notRequired().nullable(),
      }),
  }),
  foreign: yup.object().when('isForeign', {
    is: true,
    then: yup
      .object()
      .nullable()
      .shape({
        municipality: yup.object().shape({}).nullable(),
        state: yup.object().shape({}).nullable(),
      }),
    otherwise: yup
      .object()
      .nullable()
      .shape({
        municipality: yup.object().shape({}).nullable().notRequired(),
        state: yup.object().shape({}).notRequired().nullable(),
      }),
  }),
  eventDate: yup.date().nullable().typeError('Data non valida'),
  from: yup
    .date()
    .typeError('Data non valida')
    .nullable()
    .max(DateTime.now(), 'Il campo valido dal non può essere maggiore della data odierna'),
  // ATTO
  municipality: yup.object().nullable(),
  year: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .matches(regexYear, 'Il campo deve essere una data');
    // }
    return yup.string().nullable().matches(regexYear, 'Il campo deve essere una data');
  }),
  documentNumber: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri');
    // }
    return yup
      .string()
      .nullable()
      .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri');
  }),
  range: yup
    .string()
    .nullable()
    .when('italian.municipality', () => {
      // if (value?.id === ISTAT_MILANO) {
      //   return yup
      //     .string()
      //     .required('Campo obbligatorio')
      //     .matches(seriesRegex, 'Il campo non è valido');
      // }
      return yup.string().nullable().matches(seriesRegex, 'Il campo non è valido');
    }),
  regVol: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .matches(volumeRegex, 'Il campo non è valido');
    // }
    return yup.string().nullable().matches(volumeRegex, 'Il campo non è valido');
  }),
  documentDate: yup
    .date()
    .typeError('Data non valida')
    .when('italian.municipality', () => {
      // if (value?.id === ISTAT_MILANO) {
      //   return yup
      //     .date()
      //     .required('Campo obbligatorio')
      //     .nullable()
      //     .typeError('Data non valida')
      //     .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna');
      // }
      return yup
        .date()
        .nullable()
        .typeError('Data non valida')
        .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna');
    }),
  portion: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .nullable()
    //     .matches(portionRegex, 'Il campo non è valido');
    // }
    return yup.string().nullable().matches(portionRegex, 'Il campo non è valido');
  }),
});

const voidMarriageSchema = yup
  .object()
  .nullable()
  .shape({
    type: yup.string().nullable(),
    eventDate: yup
      .date()
      .nullable()
      .typeError('Formato non valido')
      .max(
        DateTime.local().plus({ days: 1 }),
        'La data non può essere successiva alla data odierna'
      ),
    validityDate: yup
      .date()
      .nullable()
      .typeError('Formato non valido')
      .max(
        DateTime.local().plus({ days: 1 }),
        'La data non può essere successiva alla data odierna'
      ),
    authority: yup.string().nullable(),
    municipality: yup.object().shape({}).nullable(),
    year: yup.string().nullable().matches(regexYear, 'Il campo deve essere una data'),
    documentNumber: yup
      .string()
      .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri')
      .nullable(),
    range: yup.string().nullable().matches(seriesRegex, 'Il campo non è valido'),
    regVol: yup.string().matches(volumeRegex, 'Il campo non è valido').nullable(),
    documentDate: yup
      .date()
      .typeError('Data non valida')
      .nullable()
      .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna'),
    portion: yup.string().nullable().matches(portionRegex, 'Il campo non è valido'),
  });

const voidCivilUnionSchema = yup.object().shape({
  // eventDate: yup.date().nullable().required('Il campo è obbligatorio'),
  // validityDate: yup.date().nullable().required('Il campo è obbligatorio'),
  // authority: yup.string().required('Campo obbligatorio').nullable(),
  // courtType: yup.string().nullable().required('Il campo è obbligatorio'),
  // municipality: yup.object().shape({}).nullable().required('Il campo è obbligatorio'),
  // year: yup
  //   .string()
  //   .matches(regexYear, 'Il campo deve essere una data')
  //   .required('Campo obbligatorio'),
  // number: yup.string().notRequired().nullable().matches(alphanumericRegex, 'Il campo non è valido'),
  // portion: yup
  //   .string()
  //   .required('Campo obbligatorio')
  //   .matches(alphanumericRegex, 'Il campo non è valido'),
  // range: yup.string().matches(alphanumericRegex, 'Il campo non è valido'),
  // documentNumber: yup
  //   .string()
  //   .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri')
  //   .required('Campo obbligatorio'),
  // regVol: yup.string().matches(alphanumericRegex, 'Il campo non è valido'),
  // documentDate: yup.date().nullable(),
  number: yup
    .string()
    .nullable()
    .notRequired()
    .matches(regexalphaNumericWithDotSlash, 'Il campo non è valido'),
  eventDate: yup.date().required('Campo obbligatorio').nullable(),
  validityDate: yup.date().required('Campo obbligatorio').nullable(),
  authority: yup.string().required('Campo obbligatorio').nullable(),
  municipality: yup.object().shape({}).nullable(),
  year: yup.string().matches(regexYear, 'Il campo deve essere una data').nullable(),
  portion: yup.string().nullable().matches(portionRegex, 'Il campo non è valido'),
  range: yup.string().matches(seriesRegex, 'Il campo non è valido').nullable(),
  documentNumber: yup
    .string()
    .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri')
    .nullable(),
  regVol: yup.string().matches(volumeRegex, 'Il campo non è valido').nullable(),
  documentDate: yup.date().nullable(),
});

export const civilUnionSchema = yup.object().shape({
  generality: generalityPerson,
  citizenship: yup.object().shape({}).nullable(),
  eventDate: yup.date().typeError('Data non valida').nullable(),
  isForeign: yup.boolean(),
  italian: yup.object().when('isForeign', {
    is: false,
    then: yup.object().shape({
      municipality: yup.object().nullable().shape({}),
    }),
    otherwise: yup.object().shape({
      municipality: yup.object().notRequired().nullable().shape({}),
    }),
  }),
  foreign: yup.object().when('isForeign', {
    is: true,
    then: yup.object().shape({
      municipality: yup.object().shape({}).nullable(),
      state: yup.object().shape({}).nullable(),
    }),
    otherwise: yup.object().shape({
      municipality: yup.object().shape({}).nullable().notRequired(),
      state: yup.object().shape({}).notRequired().nullable(),
    }),
  }),
  from: yup
    .date()
    .typeError('Data non valida')
    .nullable()
    .min(DateTime.now().minus({ day: 1 }), 'La data non può essere inferiore alla data odierna'),
  // ATTO
  municipality: yup.object().shape({}).nullable(),
  year: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .matches(regexYear, 'Il campo deve essere una data');
    // }
    return yup.string().nullable().matches(regexYear, 'Il campo deve essere una data');
  }),
  documentNumber: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri');
    // }
    return yup
      .string()
      .nullable()
      .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri');
  }),
  range: yup
    .string()
    .nullable()
    .when('italian.municipality', () => {
      // if (value?.id === ISTAT_MILANO) {
      //   return yup
      //     .string()
      //     .required('Campo obbligatorio')
      //     .matches(seriesRegex, 'Il campo non è valido');
      // }
      return yup.string().nullable().matches(seriesRegex, 'Il campo non è valido');
    }),
  regVol: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .matches(volumeRegex, 'Il campo non è valido');
    // }
    return yup.string().nullable().matches(volumeRegex, 'Il campo non è valido');
  }),
  documentDate: yup
    .date()
    .typeError('Data non valida')
    .when('italian.municipality', () => {
      // if (value?.id === ISTAT_MILANO) {
      //   return yup
      //     .date()
      //     .required('Campo obbligatorio')
      //     .nullable()
      //     .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna');
      // }
      return yup
        .date()
        .nullable()
        .typeError('Data non valida')
        .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna');
    }),
  portion: yup.string().when('italian.municipality', () => {
    // if (value?.id === ISTAT_MILANO) {
    //   return yup
    //     .string()
    //     .required('Campo obbligatorio')
    //     .nullable()
    //     .matches(portionRegex, 'Il campo non è valido');
    // }
    return yup.string().nullable().matches(portionRegex, 'Il campo non è valido');
  }),
});

// const residencyPermitSchema = yup.object().shape({
//   number: yup
//     .string()
//     .required('Campo obbligatorio')
//     .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
//   type: yup.string().required('Campo obbligatorio'),
//   releaseDate: yup
//     .date()
//     .nullable()
//     .typeError('Formato non valido')
//     .required('Campo obbligatorio')
//     .max(DateTime.local().plus({ days: 1 }), 'La data non può essere successiva alla data odierna'),
//   expirationDate: yup
//     .date()
//     .nullable()
//     .typeError('Formato non valido')
//     .required('Campo obbligatorio'),
//   policeForceRelease: yup
//     .string()
//     .nullable()
//     .required('Campo obbligatorio')
//     .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
//   passportNumber: yup
//     .string()
//     .nullable()
//     .required('Campo obbligatorio')
//     .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
// });

export const getValidationSchema = (skipBirthActPartCheck = false): yup.AnyObjectSchema =>
  yup
    .object({
      generality: generalitySchema,
      birthdayDocument: yup.object({}).shape({
        municipality: yup.object().shape({}).nullable(),
        portion: skipBirthActPartCheck
          ? yup.string().nullable()
          : yup.string().matches(portionRegex, 'Il campo può essere solo un numero tra 1 e 2'),
        documentNumber: yup.string().matches(regexOnlyNumber, 'Il campo non è valido'),
        volume: yup.string().matches(volumeRegex, 'Il campo non è valido'),
        serie: yup.string().matches(seriesRegex, 'Il campo non è valido'),
        year: yup.string().matches(regexYear, 'Il campo deve essere una data'),
        documentDate: yup.date().nullable().notRequired().typeError('Formato non valido'),
      }),
      paternity: parentSchema,
      maternity: parentSchema,
      civilStatus: civilStatusSchema,
      marriage: yup
        .object()
        .nullable()
        .when('civilStatus', (civilStatus: AccordionCivilStatus, formValidationSchema) => {
          return civilStatus.status === CivilStatusID.coniugato ||
            civilStatus.status === CivilStatusID.vedovo ||
            civilStatus.status === CivilStatusID.divorziato
            ? marriageSchema
            : formValidationSchema.nullable();
        }),
      widowhood: yup
        .object()
        .nullable()
        .when('civilStatus', (civilStatus: AccordionCivilStatus, formValidationSchema) => {
          return civilStatus.status === CivilStatusID.vedovo
            ? widowhoodSchema
            : formValidationSchema.nullable();
        }),
      voidMarriage: yup
        .object()
        .nullable()
        .when('civilStatus', (civilStatus: AccordionCivilStatus, formValidationSchema) => {
          return civilStatus.status === CivilStatusID.divorziato
            ? voidMarriageSchema
            : formValidationSchema.nullable();
        }),
      civilUnion: yup
        .object()
        .nullable()
        .when('civilStatus', (civilStatus: AccordionCivilStatus, formValidationSchema) => {
          return civilStatus.status === CivilStatusID.unitoCivilmente ||
            civilStatus.status === CivilStatusID.scioglimentoUnitoCivilmente
            ? civilUnionSchema
            : formValidationSchema.nullable();
        }),
      voidCivilUnion: yup
        .object()
        .nullable()
        .when('civilStatus', (civilStatus: AccordionCivilStatus, formValidationSchema) => {
          return civilStatus.status === CivilStatusID.scioglimentoUnitoCivilmente
            ? voidCivilUnionSchema
            : formValidationSchema.nullable();
        }),
      citizenship: yup.array().nullable().min(1, 'Selezionare almeno una cittadinanza'),
      // drivingLicenseBooklet: drivingLicenseBookletSchema,
      // identityCard: identityCardSchema,
      // residencyPermit: residencyPermitSchema,
    })
    // controlli per MATRIMONIO
    // START
    .test('generality.fiscalCode', 'Formato non valido', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;
      const fiscalCode = valuesCasted?.generality?.fiscalCode;

      if (fiscalCode) {
        if (regexNumericFiscalCode.test(fiscalCode) && fiscalCode?.length < 11) {
          return new yup.ValidationError(
            'Codice fiscale numerico non valido',
            undefined,
            'generality.fiscalCode'
          );
        }
        if (!fiscalCodeRegex.test(fiscalCode)) {
          return new yup.ValidationError(
            'Codice fiscale non valido',
            undefined,
            'generality.fiscalCode'
          );
        }
      }
      return true;
    })
    .test('marriage.municipality', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      if (valuesCasted.marriage?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.marriage?.municipality?.description) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.municipality');
      // }

      return false;
    })
    .test('marriage.generality', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      const civilStatus = String(valuesCasted?.civilStatus?.status);

      // stato civile coniugato oppure italiano e divorziato o vedovo
      // dati matrimonio obbligatori
      if (
        civilStatus === CivilStatusID.coniugato ||
        (!values.generality?.isForeign &&
          (civilStatus === CivilStatusID.divorziato || civilStatus === CivilStatusID.vedovo))
      ) {
        const errors: Array<yup.ValidationError> = [];

        if (
          !valuesCasted?.marriage?.generality?.withoutName &&
          !valuesCasted?.marriage?.generality?.name
        ) {
          errors.push(
            new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.generality.name')
          );
        }

        if (
          !valuesCasted?.marriage?.generality?.withoutSurname &&
          !valuesCasted?.marriage?.generality?.surname
        ) {
          errors.push(
            new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.generality.surname')
          );
        }

        if (!valuesCasted?.marriage?.generality?.gender) {
          errors.push(
            new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.generality.gender')
          );
        }

        if (!valuesCasted?.marriage?.eventDate) {
          errors.push(
            new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.eventDate')
          );
        }

        if (!valuesCasted?.marriage?.isForeign) {
          if (!valuesCasted?.marriage?.italian?.municipality) {
            errors.push(
              new yup.ValidationError(
                'Campo obbligatorio',
                undefined,
                'marriage.italian.municipality'
              )
            );
          }
        } else {
          if (!valuesCasted?.marriage?.foreign?.state) {
            errors.push(
              new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.foreign.state')
            );
          }

          if (!valuesCasted?.marriage?.foreign?.municipality) {
            errors.push(
              new yup.ValidationError(
                'Campo obbligatorio',
                undefined,
                'marriage.foreign.municipality'
              )
            );
          }
        }

        // Se divorziato e italiano chiedere i dati obbligatori
        if (civilStatus === CivilStatusID.divorziato) {
          if (!valuesCasted.voidMarriage?.eventDate) {
            errors.push(
              new yup.ValidationError('Campo obbligatorio', undefined, 'voidMarriage.eventDate')
            );
          }
          if (!valuesCasted.voidMarriage?.type) {
            errors.push(
              new yup.ValidationError('Campo obbligatorio', undefined, 'voidMarriage.type')
            );
          }
          if (!valuesCasted.voidMarriage?.validityDate) {
            errors.push(
              new yup.ValidationError('Campo obbligatorio', undefined, 'voidMarriage.validityDate')
            );
          }
          if (!valuesCasted.voidMarriage?.authority) {
            errors.push(
              new yup.ValidationError('Campo obbligatorio', undefined, 'voidMarriage.authority')
            );
          }
        }

        // Se vedovo e italiano chiedere i dati obbligatori
        if (civilStatus === CivilStatusID.vedovo) {
          if (!valuesCasted.widowhood?.eventDate) {
            errors.push(
              new yup.ValidationError('Campo obbligatorio', undefined, 'widowhood.eventDate')
            );
          }
          if (!valuesCasted.widowhood?.isForeign) {
            if (!valuesCasted.widowhood?.italian?.municipality) {
              errors.push(
                new yup.ValidationError(
                  'Campo obbligatorio',
                  undefined,
                  'widowhood.italian.municipality'
                )
              );
            }
          } else {
            if (!valuesCasted.widowhood?.foreign?.municipality) {
              errors.push(
                new yup.ValidationError(
                  'Campo obbligatorio',
                  undefined,
                  'widowhood.foreign.municipality'
                )
              );
            }

            if (!valuesCasted.widowhood?.foreign?.state) {
              errors.push(
                new yup.ValidationError('Campo obbligatorio', undefined, 'widowhood.foreign.state')
              );
            }
          }
        }

        if (errors?.length === 0) {
          return true;
        }

        return new yup.ValidationError(errors);
      }
      return true;
    })
    // CONTROLLI ATTO NEL MATRIMONIO
    // START
    .test('marriage.municipality', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      const withAct = Boolean(
        valuesCasted.marriage?.documentDate ||
          valuesCasted.marriage?.municipality?.description ||
          valuesCasted.marriage?.year ||
          valuesCasted.marriage?.documentNumber ||
          valuesCasted.marriage?.portion ||
          valuesCasted.marriage?.range ||
          valuesCasted.marriage?.regVol
      );

      if (withAct && !valuesCasted.marriage?.municipality?.description) {
        return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.municipality');
      }

      return false;
    })
    .test('marriage.year', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      const withAct = Boolean(
        valuesCasted.marriage?.documentDate ||
          valuesCasted.marriage?.municipality?.description ||
          valuesCasted.marriage?.year ||
          valuesCasted.marriage?.documentNumber ||
          valuesCasted.marriage?.portion ||
          valuesCasted.marriage?.range ||
          valuesCasted.marriage?.regVol
      );

      if (withAct && !valuesCasted.marriage?.year) {
        return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.year');
      }

      return false;
    })
    .test('marriage.documentNumber', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      const withAct = Boolean(
        valuesCasted.marriage?.documentDate ||
          valuesCasted.marriage?.municipality?.description ||
          valuesCasted.marriage?.year ||
          valuesCasted.marriage?.documentNumber ||
          valuesCasted.marriage?.portion ||
          valuesCasted.marriage?.range ||
          valuesCasted.marriage?.regVol
      );

      if (withAct && !valuesCasted.marriage?.documentNumber) {
        return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.documentNumber');
      }

      return false;
    })
    .test('marriage.portion', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      const withAct = Boolean(
        valuesCasted.marriage?.documentDate ||
          valuesCasted.marriage?.municipality?.description ||
          valuesCasted.marriage?.year ||
          valuesCasted.marriage?.documentNumber ||
          valuesCasted.marriage?.portion ||
          valuesCasted.marriage?.range ||
          valuesCasted.marriage?.regVol
      );

      if (withAct && !valuesCasted.marriage?.portion) {
        return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.portion');
      }

      return false;
    })
    .test('civilUnion.generality', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;
      const civilStatus = String(valuesCasted?.civilStatus?.status);

      if (
        civilStatus === CivilStatusID.unitoCivilmente ||
        civilStatus === CivilStatusID.scioglimentoUnitoCivilmente
      ) {
        const errors: Array<yup.ValidationError> = [];

        if (
          !valuesCasted?.civilUnion?.generality?.withoutName &&
          !valuesCasted?.civilUnion?.generality?.name
        ) {
          errors.push(
            new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.generality.name')
          );
        }

        if (
          !valuesCasted?.civilUnion?.generality?.withoutSurname &&
          !valuesCasted?.civilUnion?.generality?.surname
        ) {
          errors.push(
            new yup.ValidationError(
              'Campo obbligatorio',
              undefined,
              'civilUnion.generality.surname'
            )
          );
        }

        if (!valuesCasted?.civilUnion?.generality?.gender) {
          errors.push(
            new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.generality.gender')
          );
        }

        if (!valuesCasted?.civilUnion?.eventDate) {
          errors.push(
            new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.eventDate')
          );
        }
        if (!valuesCasted?.civilUnion?.isForeign) {
          if (!valuesCasted?.civilUnion?.italian?.municipality) {
            errors.push(
              new yup.ValidationError(
                'Campo obbligatorio',
                undefined,
                'civilUnion.italian.municipality'
              )
            );
          }
        } else {
          if (!valuesCasted?.civilUnion?.foreign?.state) {
            errors.push(
              new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.foreign.state')
            );
          }

          if (!valuesCasted?.civilUnion?.foreign?.municipality) {
            errors.push(
              new yup.ValidationError(
                'Campo obbligatorio',
                undefined,
                'civilUnion.foreign.municipality'
              )
            );
          }
        }

        if (errors?.length === 0) {
          return true;
        }

        return new yup.ValidationError(errors);
      }
      return true;
    })
    .test('marriage.year', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      if (valuesCasted.marriage?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.marriage?.year) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.year');
      // }

      return false;
    })
    .test('marriage.documentNumber', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      if (valuesCasted.marriage?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.marriage?.documentNumber) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.documentNumber');
      // }

      return false;
    })
    .test('marriage.portion', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.coniugato ||
          valuesCasted.civilStatus?.status === CivilStatusID.vedovo ||
          valuesCasted.civilStatus?.status === CivilStatusID.divorziato
        )
      ) {
        // caso in cui non è matrimonio
        return false;
      }

      if (valuesCasted.marriage?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.marriage?.portion) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.portion');
      // }

      return false;
    })
    // END
    // controlli per UNIONE CIVILE
    // START
    .test('civilUnion.municipality', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.unitoCivilmente ||
          valuesCasted.civilStatus?.status === CivilStatusID.scioglimentoUnitoCivilmente
        )
      ) {
        // caso in cui non è unione civile
        return false;
      }

      if (valuesCasted.civilUnion?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.civilUnion?.municipality?.description) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.municipality');
      // }

      return false;
    })
    .test('civilUnion.year', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.unitoCivilmente ||
          valuesCasted.civilStatus?.status === CivilStatusID.scioglimentoUnitoCivilmente
        )
      ) {
        // caso in cui non è unione civile
        return false;
      }

      if (valuesCasted.civilUnion?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.civilUnion?.year) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.year');
      // }

      return false;
    })
    .test('civilUnion.documentNumber', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.unitoCivilmente ||
          valuesCasted.civilStatus?.status === CivilStatusID.scioglimentoUnitoCivilmente
        )
      ) {
        // caso in cui non è unione civile
        return false;
      }

      if (valuesCasted.civilUnion?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.civilUnion?.documentNumber) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.documentNumber');
      // }

      return false;
    })
    .test('civilUnion.portion', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        !(
          valuesCasted.civilStatus?.status === CivilStatusID.unitoCivilmente ||
          valuesCasted.civilStatus?.status === CivilStatusID.scioglimentoUnitoCivilmente
        )
      ) {
        // caso in cui non è unione civile
        return false;
      }

      if (valuesCasted.civilUnion?.generality?.isForeign && valuesCasted.generality?.isForeign) {
        // se entrambi nati in italia controllare l'obbligatorietà altrimenti NO
        return false;
      }

      // if (!valuesCasted.civilUnion?.portion) {
      //   return new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.portion');
      // }

      return false;
    })
    // END
    .test('birthdayDocument.documentDate', 'Campo obbligatorio', (values) => {
      const valuesCasted = values as unknown as NewPersonVM;

      if (
        valuesCasted?.generality?.birthDate &&
        valuesCasted?.birthdayDocument?.documentDate &&
        valuesCasted?.generality?.birthDate?.toString() !== 'Invalid Date' &&
        valuesCasted?.birthdayDocument?.documentDate?.toString() !== 'Invalid Date' &&
        valuesCasted?.birthdayDocument?.documentDate < valuesCasted?.generality?.birthDate
      ) {
        return new yup.ValidationError(
          'La data non deve essere minore uguale della Data di nascita',
          undefined,
          'birthdayDocument.documentDate'
        );
      }
      // // atto di nascita obbligatorio solo se persona nata a Milano
      // if (
      //   !valuesCasted?.generality?.isForeign &&
      //   valuesCasted.generality?.italian?.municipality?.istatCode === ISTAT_MILANO
      // ) {
      //   const keys = ['municipality', 'portion', 'documentNumber', 'volume', 'year'] as Array<
      //     keyof BirthdayDocument
      //   >;

      //   const birthdayDocumentObject = valuesCasted?.birthdayDocument || {};

      //   const errors = keys
      //     .map((key) => {
      //       if (birthdayDocumentObject[key]) {
      //         return null;
      //       } // Successful validation, no error

      //       return new yup.ValidationError(
      //         'Il campo è obbligatorio',
      //         birthdayDocumentObject[key],
      //         `birthdayDocument.${key}`
      //       );
      //     })
      //     .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
      //   if (errors.length === 0) {
      //     return true;
      //   }
      //   return new yup.ValidationError(errors);
      // }

      return false;
    });
// .test('marriage.regVol', 'Campo obbligatorio', (values) => {
//   const valuesCasted = values as unknown as NewPersonVM;

//   // if (valuesCasted.marriage?.municipality?.istatCode === ISTAT_MILANO) {
//   //   return new yup.ValidationError('Campo obbligatorio', undefined, 'marriage.regVol');
//   // }

//   return false;
// })
// .test('civilUnion.regVol', 'Campo obbligatorio', (values) => {
//   const valuesCasted = values as unknown as NewPersonVM;

//   // if (valuesCasted.civilUnion?.municipality?.istatCode === ISTAT_MILANO) {
//   //   return new yup.ValidationError('Campo obbligatorio', undefined, 'civilUnion.regVol');
//   // }

//   return false;
// });
